import { LOAD_DATA } from './app';

/*******************************************************************************
 *
 *   1. Default State
 *   2. Action Types
 *   3. Action Creators
 *   4. Reducers
 *
 */

/*******************************************************************************
 *  1. Default State
 */

export const initialState = {};

/*******************************************************************************
 *  2. Action Types
 */

/*******************************************************************************
 *  3. Action Creators
 */

/*******************************************************************************
 *  4. Reducers
 */

export default function env( state = initialState, action ) {

    switch ( action.type ) {

        case LOAD_DATA:
            return {
                ...state,
                ...action.data.env
            };
            
        default:
            return state;
    }
}
